@if (editMode) {
  <h1 mat-dialog-title>Rediger Afregningslinie</h1>
}
@if (!editMode) {
  <h1 mat-dialog-title>Opret Afregningslinie</h1>
}
<button class="btn-close btn-icon" mat-dialog-close title="Luk dialog">
  <mat-icon class="material-icons">close</mat-icon>
</button>

<div mat-dialog-content>
  <form [formGroup]="form" autocomplete="off">
    <mat-form-field appearance="outline">
      <mat-label>Varenr.</mat-label>
      <input type="number" formControlName="okKundeVarenr" matInput step="1" />
      @if (vareInfoCollected) {
        <button type="button" matSuffix mat-icon-button aria-label="Clear" (click)="clearVareInfo()">
          <mat-icon>close</mat-icon>
        </button>
      }
      <mat-hint [matTooltip]="!vareInfoCollected ? 'Udfyld varenr. felt for at hente vareinfo' : ''">
        <button
          class="btn-icon"
          [class.blue]="!vareInfoCollected"
          [class.green]="vareInfoCollected"
          [disabled]="!okKundeVarenr.value || stkPrisExclMoms.value"
          (click)="getInfoForVareNr(okKundeVarenr.value)"
        >
          @if (!vareInfoCollected) {
            <mat-icon svgIcon="download"></mat-icon>
          }
          @if (vareInfoCollected) {
            <mat-icon svgIcon="checkmark"></mat-icon>
          }
          @if (!vareInfoCollected) {
            <span>Hent vareinfo fra G4</span>
          }
          @if (vareInfoCollected) {
            <span>Vareinfo hentet fra G4</span>
          }
        </button>
      </mat-hint>
    </mat-form-field>
    @if (noVareInfoInG4) {
      <div class="red tiny-text">Varen findes ikke i G4 - eller har ingen pris i G4.</div>
    }
    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>Produkt</mat-label>
        <input formControlName="produkt" matInput />
      </mat-form-field>
    </div>
    <div class="form-row flex">
      <div class="form-row form-row--inline no-min-width no-margin-top">
        <mat-form-field appearance="outline">
          <mat-label>Antal</mat-label>
          <input type="number" formControlName="antal" matInput />
        </mat-form-field>
      </div>
      <div class="form-row form-row--inline no-min-width no-margin-top">
        <mat-form-field appearance="outline">
          <mat-label>Pris (ekskl. moms)</mat-label>
          <input type="number" formControlName="stkPrisExclMoms" matInput step="1" />
        </mat-form-field>
      </div>
    </div>
    <div>
      @if (isNaerVarmeLeasingGasTryghed) {
        <span class="bold red">
          Bemærk at på leasing, nærvarme og gasfinansiering vil varenummeret blive erstattet af et default til respektiv aftaleform
        </span>
      }
    </div>
  </form>
</div>
<div mat-dialog-actions class="row-reverse">
  @if (!editMode) {
    <button mat-raised-button color="primary" (click)="save()" [disabled]="form.invalid">Tilføj</button>
  }
  @if (editMode) {
    <button mat-raised-button color="primary" (click)="save()" [disabled]="form.invalid">Gem</button>
  }
  <button (click)="cancel()" class="modal-cancel" mat-raised-button>Fortryd</button>
</div>
